import { ProfileEditPage } from "@features/security/components/ProfileEditPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

/**
 * Security — Profile Edit Route
 *
 * Form to edit an existing profile's permissions.
 * Access requires security.profiles.edit permission.
 */
export const Route = createFileRoute("/_app/admin/profiles/$id/edit")({
  loader: requirePermission(PERMISSIONS.SECURITY.PROFILES.EDIT),
  staticData: {
    title: "Modifier profil",
    permission: PERMISSIONS.SECURITY.PROFILES.EDIT,
  },
  component: ProfileEditPage,
});
